import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Landing from "@/pages/Landing";
import Explorer from "@/pages/Explorer";
import PilotGame from "@/pages/PilotGame";
import Rooms from "@/pages/Rooms";
import Wallet from "@/pages/Wallet";
import AdminPayouts from "@/pages/AdminPayouts";
import Admin from "@/pages/Admin";
import Ranking from "@/pages/Ranking";
import AuthCallback from "@/pages/AuthCallback";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import { AuthProvider } from "@/lib/auth";
import { Toaster } from "@/components/ui/sonner";
import { FEATURES } from "@/lib/features";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/explorer" element={FEATURES.explorer ? <Explorer /> : <Navigate to="/" replace />} />
      <Route path="/pilot" element={<PilotGame />} />
      <Route path="/rooms" element={FEATURES.rooms ? <Rooms /> : <Navigate to="/" replace />} />
      <Route path="/carteira" element={<Wallet />} />
      <Route path="/painel-ufo-2077" element={<AdminPayouts />} />
      <Route path="/mission-control-51" element={<Admin />} />
      <Route path="/ranking" element={<Ranking />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="grain-overlay">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
